import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { Collections } from "@graylog/enterprise-api";
import FiltersForQueryParams from "components/common/EntityFilters/FiltersForQueryParams";
import { defaultOnError } from "util/conditional/onError";
const INITIAL_DATA = {
  pagination: { total: 0 },
  list: [],
  attributes: []
};
export const COLLECTION_CANDIDATES_QUERY_KEY = "collection_entities_candidates";
export const keyFn = (collectionId, searchParams) => [
  COLLECTION_CANDIDATES_QUERY_KEY,
  collectionId,
  searchParams
];
export const fetchPaginatedCollectionCandidates = async (collectionId, searchParams) => Collections.getCandidateEntitiesPage(
  searchParams.sort.attributeId,
  collectionId,
  searchParams.page,
  searchParams.pageSize,
  searchParams.query,
  FiltersForQueryParams(searchParams.filters),
  searchParams.sort.direction
).then(({ elements, query, attributes, pagination: { count, total, page, per_page: perPage } }) => ({
  list: elements,
  attributes,
  pagination: {
    count,
    total,
    page,
    perPage,
    query
  }
}));
const useCollectionCandidates = (collectionId, searchParams, { enabled } = { enabled: true }) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: keyFn(collectionId, searchParams),
    queryFn: () => defaultOnError(
      fetchPaginatedCollectionCandidates(collectionId, searchParams),
      "Loading Collection candidate entities failed with status",
      "Could not load Collection canditate entities"
    ),
    placeholderData: keepPreviousData,
    enabled
  });
  return {
    data: data != null ? data : INITIAL_DATA,
    isLoading,
    refetch
  };
};
export default useCollectionCandidates;
